import React from 'react';

import styled from '@benzinga/themetron';

export const PreferenceSection: React.FC<
  React.PropsWithChildren<{
    title: string | React.ReactElement;
    subtitle?: string | React.ReactElement;
  }>
> = props => (
  <Section>
    <Title>{props.title}</Title>
    {props.subtitle && <SubTitle>{props.subtitle}</SubTitle>}
    {props.children}
  </Section>
);

const Section = styled.div`
  padding: 1em 0em;
`;

const Title = styled.div`
  color: ${props => props.theme.colors.foreground};
  font-weight: 300;
  font-size: 1.5em;
  border-bottom: 1px solid ${props => props.theme.colors.backgroundInactive};
  padding-bottom: 0.5em;
  margin-bottom: 1em;
`;

const SubTitle = styled.div`
  color: ${props => props.theme.colorPalette.gray500};
  margin-top: -1.25em;
  margin-bottom: 1.75em;
  font-size: (12 / 14) * 1em;
  font-weight: 400;
`;
